module.exports = __webpack_public_path__ + "static/media/banner-clients-05.3a41bb79.jpg";